import {
	setBatchEvents,
	setBatchEventsArticleShareButtons
} from 'front/shared/assets/scripts/setBatchEvents'
import Toast from 'shared/toast/toast'

export default class ShareButtons {
	private shareButtons: Element
	private shareTitle: string | undefined
	private shareUrl: string | undefined
	private buttonTooltip: HTMLElement | null
	private tooltip: HTMLElement | null
	private buttons: Record<string, Element | null>
	private hasTouchSupport: boolean

	constructor(element: Element) {
		this.shareButtons = element
		this.buttonTooltip = this.shareButtons?.querySelector('.shareButtons-buttonTooltip')
		this.tooltip = this.shareButtons?.querySelector('.shareButtons-tooltip')
		this.shareTitle = this.tooltip?.getAttribute('data-share-settitle') ?? ''
		this.shareUrl = this.tooltip?.getAttribute('data-share-setlinkback') ?? ''

		this.buttons = {}
		const buttonMapping = {
			btnFacebook: '.shareButtons-facebook',
			btnPinterest: '.shareButtons-pinterest',
			btnX: '.shareButtons-x',
			btnLinkedin: '.shareButtons-linkedin',
			btnCopylink: '.copyLink-button'
		}

		for (const [key, className] of Object.entries(buttonMapping)) {
			const element = this.shareButtons?.querySelector(className)
			this.buttons[key] = element
		}

		this.hasTouchSupport = this.checkTouchSupport()

		this.handleDocumentClick = this.handleDocumentClick.bind(this)
	}

	init() {
		if (!this.shareButtons) {
			return
		}

		for (const key in this.buttons) {
			if (this.buttons[key] !== null) {
				this.addEvent(key, this.buttons[key] as HTMLElement)
			}
		}

		this.setShare()
	}

	private checkTouchSupport(): boolean {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0
	}

	private setShare(): void {
		if (this.hasTouchSupport && navigator.share) {
			this.buttonTooltip?.addEventListener('click', () => {
				setBatchEvents(setBatchEventsArticleShareButtons)
				navigator.share({
					title: this.shareTitle,
					url: this.shareUrl
				})
			})
		} else {
			this.buttonTooltip?.addEventListener('click', (e) => {
				e.stopPropagation()
				this.toggleTooltip(true)
			})

			this.tooltip?.addEventListener('click', (e) => {
				e.stopPropagation()
			})
		}
	}

	/**
	 * Toggle the tooltip
	 * @param value - The value to toggle the tooltip
	 */
	private toggleTooltip(value: boolean): void {
		if (value === true) {
			this.tooltip?.classList.remove('hidden')
			document.addEventListener('click', this.handleDocumentClick, {
				once: true
			})
		} else {
			this.tooltip?.classList.add('hidden')
		}
	}

	/**
	 * Handle the document click
	 */
	private handleDocumentClick(): void {
		this.toggleTooltip(false)
		document.removeEventListener('click', this.handleDocumentClick)
	}

	private addEvent(key: string, element: HTMLElement): void {
		switch (key) {
			case 'btnFacebook':
				element.addEventListener('click', () => {
					setBatchEvents(setBatchEventsArticleShareButtons)
					const strLink = `https://www.facebook.com/sharer/sharer.php?u=${this.shareUrl}`
					window.open(strLink, '', 'width=600, height=600')
				})
				break
			case 'btnX':
				element.addEventListener('click', () => {
					setBatchEvents(setBatchEventsArticleShareButtons)
					const strLink = `https://twitter.com/intent/tweet?url=${this.shareUrl}&text=${this.shareTitle}`
					window.open(strLink, '', 'width=600, height=600')
				})
				break
			case 'btnPinterest':
				element.addEventListener('click', () => {
					setBatchEvents(setBatchEventsArticleShareButtons)
					const strLink = `https://pinterest.com/pin/create/link/?url=${this.shareUrl}&description=${this.shareTitle}`
					window.open(strLink, '', 'width=600, height=600')
				})
				break
			case 'btnLinkedin':
				element.addEventListener('click', () => {
					setBatchEvents(setBatchEventsArticleShareButtons)
					const strLink = `https://www.linkedin.com/sharing/share-offsite/?url=${this.shareUrl}&title=${this.shareTitle}`
					window.open(strLink, '', 'width=600, height=600')
				})
				break
			case 'btnCopylink':
				element.addEventListener('click', () => {
					setBatchEvents(setBatchEventsArticleShareButtons)
					const url = element.getAttribute('data-url')
					if (url) {
						navigator.clipboard.writeText(url)
						const toast = new Toast({
							content: 'Lien copié dans le presse-papiers'
						})
						toast.init()
					}
				})
				break
		}
	}
}
